import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { t } from "../lib/i18n";
import { toast } from "sonner";
import { Lightning, EnvelopeSimple } from "@phosphor-icons/react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
      toast.success(t.resetEmailSent);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || t.failed);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Lightning size={32} weight="fill" className="text-[#FF0055] mx-auto" />
          <div className="text-[10px] uppercase tracking-[0.3em] font-bold text-[#FF0055] font-mono mt-3">
            // BEYX.PL
          </div>
          <h1 className="font-display font-black uppercase italic text-5xl mt-2">
            {t.forgotTitle}
          </h1>
          <p className="text-white/50 text-sm mt-2">{t.forgotSub}</p>
        </div>

        {done ? (
          <div
            data-testid="forgot-success"
            className="border border-[#00E5FF]/30 bg-[#00E5FF]/5 p-6 text-center"
          >
            <EnvelopeSimple size={32} className="text-[#00E5FF] mx-auto mb-3" />
            <p className="text-sm text-white/80">{t.resetEmailSent}</p>
            <Link
              to="/login"
              data-testid="back-to-login"
              className="inline-block mt-6 text-[10px] uppercase tracking-[0.25em] font-bold text-[#00E5FF] hover:underline"
            >
              ← {t.backToLogin}
            </Link>
          </div>
        ) : (
          <form
            onSubmit={submit}
            data-testid="forgot-form"
            className="border border-white/10 bg-[#0C0C14] p-6 space-y-4"
          >
            <div>
              <label className="text-[10px] uppercase tracking-[0.25em] font-bold text-white/40 block mb-2">
                {t.email}
              </label>
              <input
                data-testid="forgot-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full bg-transparent border border-white/15 px-4 py-3 text-sm focus:outline-none focus:border-[#00E5FF]"
              />
            </div>
            <button
              type="submit"
              disabled={busy}
              data-testid="forgot-submit"
              className="w-full px-6 py-3 bg-[#FF0055] hover:bg-[#FF3377] text-white font-bold uppercase tracking-[0.25em] text-sm transition-colors disabled:opacity-50"
            >
              {busy ? t.sending : t.sendResetLink}
            </button>
            <div className="text-xs text-white/50 text-center pt-2">
              <Link
                to="/login"
                className="text-[#00E5FF] hover:underline"
                data-testid="forgot-back-link"
              >
                ← {t.backToLogin}
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
